import React from "react"
import cx from "classnames"

type Props = {
  className?: string
  children: string | JSX.Element | any
}

function Paragraph({ children, className }: Props) {
  return (
    <p className={cx("text-gray-dark", "paragraph", className)}>{children}</p>
  )
}

export default Paragraph
